import React from 'react';
import { Trans } from 'react-i18next';

import unescape from 'lodash/unescape';

/**
 * Matchs any hexadecimal html entity
 */
const hexaRegex = /&#[xX]([0-9a-fA-F]+);/g;

/**
 * decodes any html entity (names and hexa codes)
 * @param {String} str text to be unescaped
 * @returns {string} decoded input
 */
export const unescapeHtmlEntities = str =>
    unescape(str).replace(
        hexaRegex,
        (match, hex) => String.fromCharCode(`0x${hex}`),
    );

/**
 * Renders a Trans instance unescaping special characters in template params
 * Fixes bug in react-i18next
 * Bug example: template is "Your {{name}}" and name is "&"
 * then <Trans> encodes name to be "&amp;"
 * @param {Object} props Trans props
 * @returns {Object} rendered component
 */
const UnescapedTrans = props => {
    /**
     * changes node text to unescape characters
     * @param {Object} ref react-ref
     * @returns {Object} node
     */
    const getUnescapeChildrenRef = ref =>
        ref && Array.from(ref.childNodes).forEach(node => {
            if (node.textContent) {
                const { textContent } = node;
                node.textContent = unescapeHtmlEntities(textContent);
            }
        });

    return (
        <div ref={getUnescapeChildrenRef}>
            <Trans {...props} tOptions={{ interpolation: { escapeValue: true } }} />
        </div>
    );
};

export default UnescapedTrans;
